import {Component, createRef} from "preact";
import Toolbar from "../../../../../layout/toolbar";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import SectionContainer from "../../../../../layout/section-container";
import Text from "../../../../../common/text";
import {ListManager} from "../../../../../../utilities/list-manager";
import NotificationInfiniteScrollList from "../notification-infinite-scroll-list";
import style from "./styles.scss";
import BellOutlineIcon from "mdi-preact/BellOutlineIcon";

export default class NotificationList extends Component {
    manager = new ListManager();
    notificationStoreDomain = '';
    scrollRef = createRef();

    static defaultProps = {
        onVisualized: () => {},
        freeze: true
    };

    render(props, state, context) {
        return (
            <VerticalUiContainer>
                <Toolbar class={style.toolbar}>
                    <SectionContainer style={{flexGrow: 2, justifyContent: 'flex-start'}}>
                        <div className={style.iconButton}><BellOutlineIcon/></div>
                        <ToolbarTitle><Text text={'notification.list'}/></ToolbarTitle>
                    </SectionContainer>
                </Toolbar>
                <NotificationInfiniteScrollList onVisualized={props.onVisualized} freeze={props.freeze}/>
            </VerticalUiContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/notification/notification-list/index.js